const ReactGA = require('react-ga')

const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

exports.onClientEntry = () => {
  const initializeGA = () => {
    ReactGA.initialize('UA-63104269-1')
    ReactGA.set({ appName: 'Monzo USA' })
  }

  if (hasAcceptedCookies('analytics')) {
    initializeGA()
  }

  // Remove the eventListener first to ensure it is only ever set once
  window.removeEventListener(cookieAcceptEventName, initializeGA)
  window.addEventListener(cookieAcceptEventName, initializeGA, {
    once: true,
  })
}

exports.onRouteUpdate = state => {
  if (hasAcceptedCookies('analytics')) {
    const url = new URL(state.location.href)
    // remove the query params so we don't send anything we shouldn't to GA.
    url.search = ''
    ReactGA.pageview(url.pathname)
  }
}
